// Version : 1.0.0
// Author : AGALYA

import HouseDetailsActionType from './house-details.types';

/** ***************** update House Details Start ************************/
export const houseCreateStart = (houseCredentils: any) => ({
	type: HouseDetailsActionType.HOUSE_DETAILS_CREATE_START,
	payload: houseCredentils,
});

export const houseCreateSuccess = (house: any) => ({
	type: HouseDetailsActionType.HOUSE_DETAILS_CREATE_SUCCESS,
	payload: house,
});

export const houseCreateFailure = (error: unknown) => ({
	type: HouseDetailsActionType.HOUSE_DETAILS_CREATE_FAILURE,
	payload: error,
});

export const houseResponseChanged = () => ({
	type: HouseDetailsActionType.HOUSE_DETAILS_CREATE_RESPONSE_CHANGED,
});

export const houseResponseReset = () => ({
	type: HouseDetailsActionType.HOUSE_DETAILS_CREATE_RESPONSE_REST_START,
});
/** ***************** update House Details Start ************************/
